import "../css"
import calendar from "./calendar"
import Slider from "./slider"

$(function() {
  calendar("eventCalendar")
  $(".slider").each((ix, el) => new Slider(el))
})
